var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('b-container',{staticClass:"carrousel-container",attrs:{"center":""}},[_c('b-carousel',{attrs:{"id":`carrousel-${_vm.item.id}`,"interval":4000,"controls":"","indicators":""}},_vm._l((_vm.data),function(image){return _c('b-carousel-slide',{key:image.id,attrs:{"img-src":_vm.imageSrc(image)}})}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }